import { ConnectionPositionPair } from '@angular/cdk/overlay';

export const reportTooltipPositions = {
  above: new ConnectionPositionPair(
    {
      originX: 'start',
      originY: 'top',
    },
    {
      overlayX: 'center',
      overlayY: 'bottom',
    },
  ),
  below: new ConnectionPositionPair(
    {
      originX: 'start',
      originY: 'top',
    },
    {
      overlayX: 'center',
      overlayY: 'top',
    },
  ),
  left: new ConnectionPositionPair(
    {
      originX: 'start',
      originY: 'top',
    },
    {
      overlayX: 'start',
      overlayY: 'center',
    },
  ),
  right: new ConnectionPositionPair(
    {
      originX: 'start',
      originY: 'top',
    },
    {
      overlayX: 'end',
      overlayY: 'center',
    },
  ),
};
